import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { Divider } from '../../Divider'
import { useSelectContext } from '../../Select'

import { QA_NAME_ADDRESS_SELECT_DROPDOWN_LIST_FOOTER_SHOW_MAP_BTN } from './AddressSelectDropdownListFooter.constants'

import * as styles from './AddressSelectDropdownListFooter.module.css'

import MapIcon from '../../../icons/map-pin.svg'

function AddressSelectDropdownListFooter({
  Element = 'div',
  className = styles.AddressSelectDropdownListFooter,
  onShowMap,
}) {
  const { t } = useTranslation()

  const { handleClose } = useSelectContext()

  function handleShowMap(event) {
    handleClose()

    onShowMap(event)
  }

  return (
    <Element className={className}>
      <Divider />
      <Button.Text
        beforeIconProps={{ Icon: MapIcon }}
        className={styles.showMapButton}
        qaName={QA_NAME_ADDRESS_SELECT_DROPDOWN_LIST_FOOTER_SHOW_MAP_BTN}
        text={t('Common.AddressSelectDropdownViewMapBtnKey')}
        onClick={handleShowMap}
      />
    </Element>
  )
}

export default AddressSelectDropdownListFooter
